"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPasswordPage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var change_password_1 = require("../../api/calls/user/change_password");
var forgot_password_1 = require("../../api/calls/user/forgot_password");
var main_1 = require("../../reducers/slices/main");
var user_1 = require("../../reducers/slices/user");
var universal_cookie_1 = __importDefault(require("universal-cookie"));
var ForgotPasswordPage = function () {
    var cookie = new universal_cookie_1.default();
    var dispatch = (0, react_redux_1.useDispatch)();
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _a = (0, react_1.useState)(""), cellNumberError = _a[0], setCellNumberError = _a[1];
    var _b = (0, react_1.useState)(""), otpError = _b[0], setOTPError = _b[1];
    var _c = (0, react_1.useState)(""), newPasswordError = _c[0], setNewPasswordError = _c[1];
    var _d = (0, react_1.useState)(""), confirmNewPasswordError = _d[0], setConfirmNewPasswordError = _d[1];
    var _e = (0, react_1.useState)(""), enteredOTP = _e[0], setEnteredOTP = _e[1];
    var _f = (0, react_1.useState)(""), newPassword = _f[0], setNewPassword = _f[1];
    var _g = (0, react_1.useState)(""), confirmNewPassword = _g[0], setConfirmNewPassword = _g[1];
    var _h = (0, react_1.useState)(false), isLoading = _h[0], setIsLoading = _h[1];
    (0, react_1.useEffect)(function () {
        //
    }, []);
    var validate = function () {
        var count = 0;
        setCellNumberError("");
        setOTPError("");
        setNewPasswordError("");
        setConfirmNewPasswordError("");
        if (!user.user.cell_number) {
            count++;
            setCellNumberError("Please enter your cell number to reset your password.");
        }
        if (user.user.reset_password_otp && user.user.reset_password_otp != enteredOTP) {
            count++;
            setOTPError("Entered OTP does not match the one sent to your cellphone number.");
        }
        if (user.user.reset_password_otp == enteredOTP) {
            if (!newPassword) {
                count++;
                setNewPasswordError("New password is required.");
            }
            if (newPassword !== confirmNewPassword) {
                count++;
                setConfirmNewPasswordError("Passwords do not match.");
            }
        }
        return count > 0 ? false : true;
    };
    return (react_1.default.createElement("div", { className: "flex flex-col gap-y-4 w-96 h-full justify-center" },
        react_1.default.createElement("div", { className: "text-3xl font-bold" }, "Forgot Password"),
        react_1.default.createElement("div", { className: "flex flex-col gap-y-4" },
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Cellphone Number", value: user.user.cell_number, errorText: cellNumberError, onChange: function (v) {
                    dispatch((0, user_1.setUser)(__assign(__assign({}, user), { user: __assign(__assign({}, user.user), { cell_number: v }) })));
                } }),
            user.user.reset_password_otp && (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "OTP", value: enteredOTP, errorText: otpError, onChange: function (v) {
                        setEnteredOTP(v);
                    } }),
                react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "New Password", value: newPassword, errorText: newPasswordError, onChange: function (v) {
                        setNewPassword(v);
                    } }),
                react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Confirm New Password", value: confirmNewPassword, errorText: confirmNewPasswordError, onChange: function (v) {
                        setConfirmNewPassword(v);
                    } }))),
            react_1.default.createElement("div", { className: "grid" },
                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: user.user.reset_password_otp ? "Reset Password" : "Send OTP", loading: isLoading, backgroundColor: "bg-primary", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var otp_1;
                        var _a, _b;
                        return __generator(this, function (_c) {
                            // dispatch(sign_in_thunk());
                            if (validate()) {
                                if (user.user.reset_password_otp) {
                                    setIsLoading(true);
                                    (0, change_password_1.change_password)({
                                        otp: enteredOTP,
                                        cell_number: (_a = user.user.cell_number) !== null && _a !== void 0 ? _a : "",
                                        new_password: newPassword,
                                    }).then(function (response) {
                                        setIsLoading(false);
                                        var obj = __assign(__assign({}, user), response.content);
                                        //Only set the cookie if it has been set before.
                                        //IF it has been set before, then it means that the user has checked the remember me checkbox.
                                        if (cookie.get("user_state")) {
                                            cookie.set("user_state", obj, {
                                                sameSite: true,
                                            });
                                        }
                                        dispatch((0, user_1.setUser)(obj));
                                        dispatch((0, main_1.setDrawerOpen)(false));
                                    });
                                }
                                else {
                                    setIsLoading(true);
                                    otp_1 = doshx_controls_web_1.Utilities.generateOTP();
                                    (0, forgot_password_1.forgot_password)({
                                        otp: otp_1,
                                        cell_number: (_b = user.user.cell_number) !== null && _b !== void 0 ? _b : "",
                                    }).then(function (response) {
                                        setIsLoading(false);
                                        if (response.success) {
                                            dispatch((0, user_1.setUser)(__assign(__assign({}, user), { user: __assign(__assign({}, user.user), { reset_password_otp: otp_1 }) })));
                                        }
                                        else {
                                            //Failed to send otp!
                                            // console.log("Failed to send otp!", response.message);
                                        }
                                    });
                                }
                            }
                            return [2 /*return*/];
                        });
                    }); } }))),
        react_1.default.createElement("div", { className: " text-center" },
            react_1.default.createElement("span", { className: "hover:underline cursor-pointer text-primary", onClick: function () {
                    dispatch((0, main_1.setDrawerPage)("login"));
                    // navigate(`${rootPath}/login`);
                } }, "Back to login"))));
};
exports.ForgotPasswordPage = ForgotPasswordPage;
